export type VehicleSeriesSystemDefinitionRequestBody = {
  /**
   * Definition name
   */
  name: string;
};
